import { StyleSheet, Platform } from 'react-native';
import { AdminColors } from '../../../../../Admin/constants/adminColors';
import FontFamily from '../../../../../../constants/fonts';

const isWeb = Platform.OS === 'web';

const styles = StyleSheet.create({
  // ── Outer card — border + elevation shared by every activity section ──
  card: {
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#CFE0F5',
    borderRadius: 10,
    backgroundColor: AdminColors.bgSurface,
    // No overflow:'hidden' here — it would clip the result picker dropdown rendered
    // inside CoachingHistory's body. Corner rounding instead comes from the header/body.
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 3,
    elevation: 2,
  },

  // ── Header — title left, subtitle/actions right, light blue band ──────
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingHorizontal: isWeb ? 20 : 14,
    paddingVertical: 16,
    backgroundColor: '#F3F7FD',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    gap: 12,
  },
  titleBlock: {
    flex: 1,
    gap: 4,
  },
  title: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 17 : 15,
    color: AdminColors.blue800,
  },
  description: {
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 12 : 11,
    color: AdminColors.textSecondary,
    lineHeight: 16,
  },
  subtitle: {
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 12 : 11,
    color: AdminColors.textSecondary,
    flexShrink: 1,
    textAlign: 'right',
    maxWidth: '55%',
    lineHeight: 16,
  },

  // ── Body — white content area, inset from the header band ─────────────
  body: {
    backgroundColor: AdminColors.bgSurface,
    marginHorizontal: isWeb ? 20 : 14,
    marginVertical: isWeb ? 20 : 14,
  },
});

export default styles;
